import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardSectionState, AdminDashboardSla } from "@/types/dashboard";

export type DashboardSlaState = AdminDashboardSectionState<AdminDashboardSla>;

export const dashboardSlaInitialState: DashboardSlaState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardSla",
  initialState: dashboardSlaInitialState,
  reducers: {
    setDashboardSlaAction(state, { payload }: PayloadAction<AdminDashboardSla | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardSlaErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardSlaAction, setDashboardSlaErrorAction } = slice.actions;
export default slice.reducer;
